import { toast } from "sonner";

export async function copyToClipboard(text, successMessage) {
  try {
    await navigator.clipboard.writeText(text);
    if (successMessage) toast.success(successMessage);
    return true;
  } catch (e) {
    console.warn("Clipboard write blocked", e);
    toast.error("Clipboard blocked by your browser — select the text and copy it manually");
    return false;
  }
}

export async function shareNative(data) {
  try {
    await navigator.share(data);
  } catch (e) {
    if (e?.name === "AbortError") return; // user dismissed the share sheet
    console.warn("Native share failed", e);
    toast.error("Sharing isn't available on this device — download the card instead");
  }
}

export async function shareCardImage(dataUrl, filename, text, url) {
  let payload = { text, url };
  try {
    const blob = await (await fetch(dataUrl)).blob();
    const file = new File([blob], filename, { type: "image/png" });
    if (navigator.canShare?.({ files: [file] })) payload = { files: [file], text, url };
  } catch (e) {
    console.warn("Could not attach card image to share", e);
  }
  await shareNative(payload);
}
